import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const ModalTabsContext = React.createContext();

class ModalTabs extends React.PureComponent {
    static propTypes = {
        activeTab: PropTypes.string.isRequired,
        children: PropTypes.any
    };

    render() {
        const {
            activeTab,
            children
        } = this.props;

        return (
            <ModalTabsContext.Provider value={ activeTab }>
            <div className="modal__tabs">
                { children }
            </div>
            </ModalTabsContext.Provider>
        );
    }
}

const Tab = ({ onClick, name, title }) => {
    return (
        <ModalTabsContext.Consumer>
            { activeTab => (<div className={ classnames('modal__tabs__tab', { 'modal__tabs__tab--active': name === activeTab }) }>
                { name === activeTab && <div className="modal__tabs__tab__left-corner" /> }
                <span onClick={ onClick }>{ title }</span>
            </div>) }
        </ModalTabsContext.Consumer>
    );
};

Tab.propTypes = {
    onClick: PropTypes.func.isRequired,
    name: PropTypes.string,
    title: PropTypes.string,
};

ModalTabs.Tab = Tab;

export default ModalTabs;



// WEBPACK FOOTER //
// ./src/components/general/ModalTabs.js